// Libraries
import { useState, useEffect } from "react";
import { getDeviceLabel } from "utils/device";
import UAParser from "ua-parser-js";

export const useDeviceDetect = () => {
  const [browserType, setBrowserType] = useState<string | null>();
  const [deviceType, setDeviceType] = useState<string | null>();
  const [deviceLabel, setDeviceLabel] = useState<string | null>(null);

  useEffect(() => {
    const parser = new UAParser();
    const result = parser.getResult();
    setBrowserType(result.browser.name || null);
    setDeviceType(result.device.type || null);
    setDeviceLabel(getDeviceLabel());
  }, []);

  return { browserType, deviceType, deviceLabel };
};

export default useDeviceDetect;
